import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductCode } from '../app.constants';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent {
  startPage: boolean = true;
  english: boolean = true;
  isIslamic: boolean = false;
  constructor(private route: ActivatedRoute, public router: Router) {
    router.events.subscribe(() => {
      var lang = sessionStorage.getItem('language')
      this.startPage = (
          router.url.includes('/start')  
          || ((router.url.includes('/passcode') || router.url.includes('/otp')) && lang == "")
        ) 
        && !(router.url.includes(ProductCode.Signature) || router.url.includes(ProductCode.Access));
    })
    this.route.queryParams.subscribe(params=>{
      if(router.url.includes('/start') || router.url.includes('/passcode') || router.url.includes('/otp') ||router.url.includes('/make-appointment-contact-details')) {
        if(params['product'] == ProductCode.eBizi) {
          this.isIslamic = true;
        } else {
          this.isIslamic = false;
        }
      } else {
        this.isIslamic =  sessionStorage.getItem('currentProduct') == ProductCode.eBizi;
      }
      if(params['lang'] == 'ms') {
        this.english = false;
      } else {
        this.english = true;
      }
    });
  }

  languageToggle() {
    this.english = !this.english;
    var lang = this.english ? 'en-us' : 'ms';
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        lang
      },
      queryParamsHandling: 'merge',
      skipLocationChange: false
    });
  }
}